import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { filterRoutesByAuthStep } from '@src/configs/routes';
import useLocationState from '@src/hooks/useLocationState';
import { isAuthenticatedSelector } from './store/user/user.selector';
import { privateRouteList, privateRoutes, publicRouteList, publicRoutes } from './configs/routes';
import ResultTest from './components/ResutTest';
import DepositDialog from './components/Wallet/DepositDialog';

const App = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { pathname } = useLocation();
  const isAuth = useSelector(isAuthenticatedSelector);
  const routes = filterRoutesByAuthStep(isAuth);

  useLocationState();

  useEffect(() => {
    if (pathname === '/') navigate(isAuth ? privateRoutes.dashboard : publicRoutes.login);
  }, [isAuth]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView?.({ behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    if (!isAuth && !publicRouteList.includes(pathname)) {
      navigate(publicRoutes.login, { replace: true });
    }
    if (isAuth && !privateRouteList.includes(pathname)) {
      navigate(privateRoutes.dashboard, { replace: true });
    }
  }, [isAuth]);

  return (
    <>
      <div ref={scrollRef} />

      <Routes>
        {routes.map((item) => (
          <Route path={item.route} element={item.Element} key={item.route} />
        ))}
      </Routes>

      <ResultTest />

      <DepositDialog />
    </>
  );
};

export default App;
